export { default } from './Accordion';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Accordion/index.js
// module id = 299
// module chunks = 0